// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingProfileTabs-moduleattentionDot__cpltf";
var _2 = "RentalPortalListingProfileTabs-moduleskeleton___JMxp Skeleton-moduleSkeleton__Mlrfv";
var _3 = "RentalPortalListingProfileTabs-moduletabsWrapper__B9ljB TabScrollList-modulewrapper__zIrvw";
export { _1 as "attentionDot", _2 as "skeleton", _3 as "tabsWrapper" }
